import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/contact", form); toast.success("Thank you — we'll write back soon ♡"); setForm({ name: "", email: "", message: "" }); }
    catch { toast.error("Something went wrong"); }
    setLoading(false);
  };
  return (
    <div className="max-w-xl mx-auto px-6 md:px-10 py-24 md:py-32">
      <div className="text-[11px] tracking-editorial uppercase text-[#C3B1C5]">◐ Get In Touch</div>
      <h1 className="font-serif-display text-[42px] md:text-[56px] mt-3 tracking-tight">Say hello</h1>
      <p className="mt-4 text-[14px] text-[#4A464A]/70">Questions about sizing, shipping or an order? Drop us a note.</p>
      <form onSubmit={submit} className="mt-10 space-y-5">
        <input data-testid="contact-name" required placeholder="Your name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="w-full border px-4 py-3 bg-transparent text-[14px]" style={{ borderColor: "#EBE5ED" }} />
        <input data-testid="contact-email" required type="email" placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="w-full border px-4 py-3 bg-transparent text-[14px]" style={{ borderColor: "#EBE5ED" }} />
        <textarea data-testid="contact-message" required placeholder="Message" rows={5} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} className="w-full border px-4 py-3 bg-transparent text-[14px]" style={{ borderColor: "#EBE5ED" }} />
        <button data-testid="contact-submit" disabled={loading} className="px-8 py-3.5 text-[12px] uppercase tracking-editorial" style={{ background: "#4A464A", color: "#FDFBF7" }}>{loading ? "Sending…" : "Send"}</button>
      </form>
    </div>
  );
}
